import { createContext } from "react";
import { OfflineDetectState, OfflineDetectAction } from "./OfflineDetectContextTypes";


export const OfflineDetectContext = createContext<[OfflineDetectState, (action: OfflineDetectAction) => void] | undefined>(undefined);
